import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { QuotationDetailModel } from 'src/app/models/preliminaries/quotation-detail.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { BreakdownService } from 'src/app/services/preliminaries/breakdown.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';



@Component({
  selector: 'app-apply-discount-breakdown',
  templateUrl: './apply-discount-breakdown.component.html',
  styleUrls: ['./apply-discount-breakdown.component.scss'],
  standalone: false
})
export class ApplyDiscountBreakdownComponent implements OnInit {

  formDiscount: FormGroup = new FormGroup({});
  listFamily: any[] = [];
  listGroup: any[] = [];
  listSubgroup: any[] = [];
  quotationSolutionContract: QuotationDetailModel = new QuotationDetailModel();
  subscription: Subscription;
  rateDiscountMax: number = 0;

  constructor(private articleService: ArticleService,
    private breakdownService: BreakdownService,
    private confirmDialogService: ConfirmDialogService,
    private formBuilder: FormBuilder,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) { }

  ngOnInit() {
    this.validateFormDiscount();
    this.getAllLists();

    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.subscription = input$?.subscribe((inputs: any) => {
      this.quotationSolutionContract = inputs.quotationSolutionModel;
      this.rateDiscountMax = inputs.rateDiscountMax;
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async applyDiscount() {
    const discount = this.formDiscount.get("discount")?.value ?? 0;

    const modelDiscount = this.formDiscount.value;
    if (modelDiscount.discount > this.rateDiscountMax) {
      this.toastHandlerService.showToast('warning',
        `El descuento máximo permitido para el usuario actual es del ${this.rateDiscountMax}%`, 'Atención');
      return;
    }

    const familyId = this.formDiscount.get("familyId")?.value;
    const groupId = this.formDiscount.get("groupId")?.value;
    const subgroupId = this.formDiscount.get("subgroupId")?.value;

    const response = await firstValueFrom(this.breakdownService.applyDiscount(this.quotationSolutionContract.quotationDetailId, discount, familyId, groupId, subgroupId));
    if (response) {
      const output$ = this.config.data?.output$;
      output$?.next({ type: 'updateList', payload: true });
      this.toastHandlerService.showToast('success', 'El descuento se aplico exitosamente.', '');
    }
    this.validateFormDiscount();
    if (this.ref) this.ref.close();

  }

  async getAllLists() {
    try {
      const [families, groups, subgroups] = await Promise.all([
        firstValueFrom(this.articleService.getAllFamiliesForSelectAsync()),
        firstValueFrom(this.articleService.getAllGroupsForSelectAsync()),
        firstValueFrom(this.articleService.getAllSubgroupsForSelectAsync())
      ]);

      this.listFamily = families;
      this.listGroup = groups;
      this.listSubgroup = subgroups;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getSubgroup(subgroupId: number | null) {
    if (subgroupId && subgroupId !== 0) {
      const subgroup = this.listSubgroup.find(x => x.value === subgroupId);
      if (subgroup) {
        this.formDiscount.patchValue({ groupId: subgroup.groupId, subgroupId });
        return;
      }
    }
    this.formDiscount.patchValue({ groupId: 0, subgroupId: 0 });
  }

  validateFormDiscount() {
    this.formDiscount = this.formBuilder.group({
      familyId: [0, []],
      groupId: [0, []],
      subgroupId: [0, []],
      discount: [0, []]
    })
  }
}
